import React from "react";
import Header from "../Header";
import FormBody from "./FormBody";
import Footer from "../Footer";
import LoginForm from "./LoginForm";

const SignupMainBody = ({ onLogin }) => {
  const url = window.location.href;
  return (
    <div className="wrapper">
      <Header />
      {url.includes("/signup") && <FormBody />}
      {url.includes("/login") && <LoginForm onLogin={onLogin} />}
      <Footer />
    </div>
  );
};

export default SignupMainBody;
